import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import MenuSection from './components/MenuSection';
import PaymentSection from './components/PaymentSection';
import TrackingSection from './components/TrackingSection';
import ReviewsSection from './components/ReviewsSection';
import WhyUsSection from './components/WhyUsSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <WhyUsSection />
        <MenuSection />
        <PaymentSection />
        <TrackingSection />
        <ReviewsSection />
      </main>
      <Footer />
    </div>
  );
}
